import React from 'react'
import Navbar from '../../../comp/Navbar'
import CountryServiceCard from './CountryServiceCard'
import Footer from '../../../comp/Footer';
import triangleImgIcon from "../../../assets/project.jpg"
import ScrollToTop from '../../../comp/ScrollToTop';

const ProjectServices = () => {
  const subServices = [
    {
      title: "Global Capability Center",
     
    },
    {
      title: "Migration of Accounting Systems",
   
    }
  ];
  
  return (
    <>
      <Navbar/>
      <section className="assurance-support-container">
        <h3
          style={{ marginTop: "3em", marginBottom: "1.5em" }}
          data-aos="fade"
          data-aos-duration="700"
          data-aos-once="true"
          data-aos-delay="50"
        >
          <b>Project Services</b>
        </h3>
        
        <CountryServiceCard subServices={subServices} showDetails={false} />
       
        
      </section>
      <section className="cutimage">
          <div className="cutimage1">
            <div className="emptybg"></div>
            <span className="imagestyle1">
              <span className="insidespan">
                <img
                  alt="test"
                  srcSet={triangleImgIcon}
                  style={{
                    display: "block",
                    maxWidth: "100%",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: "1",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                  }}
                ></img>
              </span>
              <img
                alt="city"
                className="imagejpg"
                decoding="async"
                src={triangleImgIcon}
              ></img>
            </span>
          </div>
        </section>
      <Footer/>
      <ScrollToTop/>
    </>
  )
}

export default ProjectServices
